import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import Contact_Us_Seo from '../../SEO/Contact_Us_Seo';
import AOS from 'aos';

function ContactUs() {
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({ name: '', email: '', phoneno: '', msg: '' });
    const [errors, setErrors] = useState({});
    const [reCaptcha, setCaptchaToken] = useState('');

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 500ms delay
    }, []);

    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);

    const validateForm = () => {
        const formErrors = {};
        if (!formData.name) {
            formErrors.name = 'Name is required';
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            formErrors.name = 'Name can only contain letters and spaces';
        }
        if (!formData.email) {
            formErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formErrors.email = 'Email address is invalid';
        }
        if (!formData.phoneno) {
            formErrors.phoneno = 'Phone number is required';
        } else if (!/^\d{10,15}$/.test(formData.phoneno)) {
            formErrors.phoneno = 'Phone number is invalid';
        }
        if (!formData.msg) {
            formErrors.msg = 'Message is required';
        }
        if (!reCaptcha) {
            formErrors.captcha = 'Captcha is required';
        }

        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateForm();
        if (!isValid) return;

        try {
            const response = await axios.post('https://ifepay.co.uk/prod/api/contactus/savecontactdetails', { ...formData, reCaptcha });
            const { responseCode, data } = response.data;

            if (responseCode === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Form submitted successfully!',
                    confirmButtonText: 'OK',
                });
                setFormData({ name: '', email: '', phoneno: '', msg: '' });
                setCaptchaToken('');
                setErrors({}); // Clear errors on success
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data || 'There was an issue submitting the form. Please try again later.',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'There was an issue submitting the form. Please try again later.',
                confirmButtonText: 'OK',
            });
            console.error('Error submitting form:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
    };

    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Contact_Us_Seo />
                    <Header />
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Contact Us</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Contact Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="contact-address-area ptb-120 overflow-hidden">
                        <div className="container">
                            <div className="address-container bg-color-theme2 radius-20">
                                <div className="contact-warp d-flex align-items-center justify-content-between" data-aos-delay={100}>
                                    <div className="location position-relative">
                                        <i className="flaticon-maps-and-flags call-icon" />
                                        <span>Address</span>
                                        <NavLink to="https://maps.app.goo.gl/B1eYbFnsuJXh78xj9" target="_blank">
                                            Suite 5, Community house,<br />19 - 21 Eastern Road,<br />Post code RM13NH, Romford
                                        </NavLink>
                                    </div>
                                    <div className="location position-relative">
                                        <i className="flaticon-phone-call call-icon" />
                                        <span>Phone Number</span>
                                        <NavLink to="tel:02030061093">02030061093</NavLink> / <NavLink to="tel:07707337351">07707337351</NavLink>
                                    </div>
                                    <div className="location position-relative">
                                        <i className="flaticon-email-1 call-icon" />
                                        <span>Email Address</span>
                                        <NavLink to="mailto:info@ifepay.co.uk">
                                            info@ifepay.co.uk
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-form-area pb-120">
                        <div className="container">
                            <div className="section-title" style={{ maxWidth: 665 }}>
                                <span className="sub-title">GET IN TOUCH</span>
                                <h2>Feel Free To Contact Us</h2>
                            </div>
                            <div className="row g-4">
                                <div className="col-lg-8 col-md-12" data-aos-delay={300}>
                                    <form className="contact-form bg-color-fffaeb radius-30" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    id="input_name"
                                                    placeholder="Enter Name*"
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                    required
                                                    className="form-control mb-2" />
                                                {errors.name && <span className="error text-danger mb-2">{errors.name}</span>}
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <input
                                                    type="text"
                                                    name="email"
                                                    id="input_email"
                                                    placeholder="Enter Email ID*"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    required
                                                    className="form-control mb-2" />
                                                {errors.email && <span className="error text-danger mb-2">{errors.email}</span>}
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <input
                                                    type="text"
                                                    name="phoneno"
                                                    id="input_phone"
                                                    placeholder="Enter Phone Number*"
                                                    value={formData.phoneno}
                                                    onChange={handleInputChange}
                                                    required
                                                    className="form-control mb-2" />
                                                {errors.phoneno && <span className="error text-danger mb-2">{errors.phoneno}</span>}
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <textarea
                                                    placeholder="Your Message"
                                                    name="msg"
                                                    value={formData.msg}
                                                    onChange={handleInputChange}
                                                    required
                                                    id="message" cols={5} rows={1} className="form-control textarea mb-2" />
                                                {errors.msg && <span className="error text-danger mb-2">{errors.msg}</span>}
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="mb-3">
                                                    <ReCAPTCHA
                                                        sitekey="6LdJXrcqAAAAAICxBuvcI8Ndx7sROqAy_tHJ2JQH"
                                                        onChange={handleCaptchaChange}
                                                    />
                                                    {errors.captcha && <span className="error text-danger mb-2">{errors.captcha}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" className="default-btn">Submit <i className="ri-arrow-right-up-line" /></button>
                                    </form>
                                </div>
                                <div className="col-lg-4 col-md-12" data-aos-delay={800}>
                                    <div className="contact-map">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2479.5731494748416!2d0.1850713!3d51.5760582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a4ca5a14881b%3A0x2cd0d9e9c18c22c!2sSAMEDAY%20OFFICE%2C%2019-21%20Eastern%20Rd%2C%20Romford%20RM1%203NH%2C%20UK!5e0!3m2!1sen!2sin!4v1736344470939!5m2!1sen!2sin" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </>
    );
}

export default ContactUs;
